// Staging Base Urls
/*export const authDomain = 'https://sso.vtc.systems/';
export const apiDomain = 'https://crm.vtc.systems';
export const filesDomain = 'https://crm.vtc.systems';*/

// Local Base Urls
export const apiDomain = 'http://vvg.crm.com/api/'; //local
//export const apiDomain = 'http://crm.vtc.systems/api/';//staging

export const configs = {
    //AUTH_API: authDomain,
    API: apiDomain,
    version:'v1',
    client_id:2,
    client_secret: process.env.VUE_APP_SECRET,
    grant_type:'password',
    access_token:'',
    refresh_token:'',
    expires_in:'' // It's better to require a config file
}


export const getuserUrl = apiDomain + 'v1/user';
export const loginUrl = apiDomain + 'v1/login';

export const employeeUrl = apiDomain + 'v1/add_employee';
export const businessUnitUrl = apiDomain + 'v1/fetch_business_unit';


export const list_taskUrl = apiDomain + 'v1/task/list';
export const addTask = apiDomain + 'v1/task/create';
export const updateTask = apiDomain + 'v1/task/update';
export const form_customerUrl = apiDomain + 'v1/form_customer';
export const listbusinessunits = apiDomain + 'v1/businessunits_list';
// export const list_taskUrl = apiDomain + 'v1/showtask';

export const listCustomer = apiDomain + 'v1/list_customer'
export const getCustomer = apiDomain + 'v1/get_customers'
export const listcallUrl = apiDomain + 'v1/listcall';
export const addCall = apiDomain + 'v1/call/create';
export const listemployee = apiDomain + 'v1/get/userslist';
export const listContactUrl = apiDomain + 'v1/contact/list';





// WEBPACK FOOTER //
// ./src/config.js